export const INVITE_FRIEND_QUEST = "inviteFriendQuest";
export const INVITE_FRIEND_QUEST_PHASE_1 = "inviteFriendQuest_phase_1";
export const INVITE_FRIEND_QUEST_PHASE_2 = "inviteFriendQuest_phase_2";
